// extracted by mini-css-extract-plugin
module.exports = {"label":"LogoApp_label__32q6S","logo_app":"LogoApp_logo_app__-d7BN"};